module.exports = __webpack_public_path__ + "static/media/preloader-Big-PennyMac-withText-Pet.04a12e1e.gif";